import { useRouter, type ErrorComponentProps } from "@tanstack/react-router";
import { PolicyDetailScreen } from "@softmax/web-ux/policies";
import { buildHref } from "@softmax/web-addresses";
import { NavigationFailure } from "@softmax/web-features/navigation/markers";

export function PolicyError({ error }: ErrorComponentProps) {
  const router = useRouter();

  return (
    <>
      <NavigationFailure />
      <PolicyDetailScreen
        back={{ href: buildHref({ name: "policies" }), label: "Policies" }}
        state={{
          status: "error",
          message: error instanceof Error ? error.message : String(error),
        }}
        onRetry={() => void router.invalidate()}
      />
    </>
  );
}
